import React, { Component } from 'react';
import ParkingTimes from 'components/bookings/parking-times';

import LocationImage from 'components/location/image';
import LocationImageHeader from 'components/location/image/header';

export default class BookingDetails extends Component {

  renderEventInfo() {
    const { booking, event, venue } = this.props;
    if (!event || !venue) { return null; }
    const eventParent = booking.package && booking.package.name ? booking.package.name : venue.name;
     if (event) {
      return (
        <div className="event-info wrap-ellipses">
          <div className='event-parent'>{eventParent}</div>
          <div className='event-name'>{event.name}</div>
        </div>
      );
    } else {
      return null
    }
  }

  render() {
    return (
      <div className='booking-details row shadowed'>
        <div className='col-xs-5 padding-0'>
          <LocationImage location={this.props.location}>
            <LocationImageHeader location={this.props.location} />
          </LocationImage>
        </div>
        <div className='col-xs-7 booking-info'>
          {this.renderEventInfo()}
          <ParkingTimes
            booking={this.props.booking}
            className="text-size-14"
            labelClassName="text-size-12 text-weight-book"
          />
          <div className="parking-pass-number">
            <span>PARKING PASS#</span>
            <strong>{this.props.booking.id}</strong>
          </div>
        </div>
      </div>
    )
  }
}
